import React from "react";
import styled, { css, keyframes } from "styled-components";
import PropTypes from "prop-types";
import { colors, header, transition } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";
import TrayContainer from "../TrayContainer";

const sheetApearing = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;

const sheetDisappearing = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(140%);
  }
`;

/* Inset handling (top / bottom env padding, position: fixed, overflow,
 * webkit-overflow-scrolling) inherited from TrayContainer. Add only
 * tray-specific concerns here: bg, max-width, animation, z-index,
 * the desktop top offset, and the open/close gating. */
const StyledContainer = styled(TrayContainer)`
  background-color: ${colors.white};
  transition: ${transition.baseTransition};
  max-width: ${(props) => props.maxWidth};
  width: 100%;
  max-height: 100%;
  min-height: 100%;
  z-index: 2200;
  ${breakpoints.mdUp} {
    top: ${header.desktopHeight};
  }
  ${(props) =>
    !props.isOpened &&
    css`
      display: none;
    `}
  animation: ${(props) => (props.hide ? sheetDisappearing : sheetApearing)};
  animation-duration: ${(props) => (props.shouldAnimate ? "0.4s" : "0s")};
`;

const AnimatingTrayContainer = ({ children, hide, isOpened, maxWidth = "500px", shouldAnimate = true }) => (
  <StyledContainer hide={hide} isOpened={isOpened} maxWidth={maxWidth} shouldAnimate={shouldAnimate}>
    {children}
  </StyledContainer>
);

AnimatingTrayContainer.propTypes = {
  children: PropTypes.node.isRequired,
  hide: PropTypes.bool.isRequired,
  isOpened: PropTypes.bool.isRequired,
  maxWidth: PropTypes.string,
  shouldAnimate: PropTypes.bool,
};

export default AnimatingTrayContainer;
